import React from "react";

export const Header = (props) => {
  const [phrase, setPhrase] = React.useState("Pro babičku do alba");

  const phraseChange = () => {
    let contactPhrases = [
      "S novou tchýní",
      "S opilým supermanem",
      "Vzhůru nohama",
      "Pro babičku do alba",
      "S dědou v paruce hipíka",
    ];

    let current_phrase_index = contactPhrases.indexOf(phrase);

    if (contactPhrases.length - 1 === current_phrase_index) {
      // end of contactPhrases. setting the value back to the first element.
      setPhrase(contactPhrases[0]);
    } else {
      // Set the phrase to the next element.
      setPhrase(contactPhrases[current_phrase_index + 1]);
    }
  };

  React.useEffect(() => {
    setTimeout(() => phraseChange(), 5000);
  }, [phrase]);
  return (
    <header id="header">
      <div className="intro">
        <div className="background-image"> </div>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>{props.data ? props.data.title : "Loading"}</h1>
                <br />
                <br />
                <br />
                <div className="intro-subtitle-container">
                  <h2 className="intro-subtitle">{phrase}</h2>
                </div>
                {/* <p>{props.data ? props.data.subtitle : "Loading"}</p> */}
                <span />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  {props.data ? props.data.paragraph : "Loading"}
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
